// src/utils/format.js

/**
 * Форматирует дату в строку "ДД.ММ.ГГГГ"
 * @param {string|Date} date - Дата
 * @returns {string}
 */
export const formatDate = (date) => {
  if (!date) return '—';
  const d = new Date(date);
  return d.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

/**
 * Форматирует время в строку "ЧЧ:ММ:СС"
 * @param {string|Date} time - Время или дата
 * @returns {string}
 */
export const formatTime = (time) => {
  if (!time) return '—';
  const d = new Date(time);
  return d.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

/**
 * Форматирует дату и время в строку "ДД.ММ.ГГГГ ЧЧ:ММ"
 * @param {string|Date} datetime - Дата и время
 * @returns {string}
 */
export const formatDateTime = (datetime) => {
  if (!datetime) return '—';
  const d = new Date(datetime);
  return d.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

/**
 * Форматирует секунды в строку "ЧЧ:ММ:СС"
 * @param {number} seconds - Длительность в секундах
 * @returns {string}
 */
export const formatDuration = (seconds) => {
  if (!seconds && seconds !== 0) return '00:00:00';
  const s = Math.max(0, Math.floor(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
};

/**
 * Форматирует размер файла в человекочитаемый вид
 * @param {number} bytes - Размер в байтах
 * @param {number} decimals - Количество знаков после запятой
 * @returns {string}
 */
export const formatFileSize = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Б';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Б', 'КБ', 'МБ', 'ГБ'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

/**
 * Обрезает текст до указанной длины и добавляет "..."
 * @param {string} text - Текст
 * @param {number} maxLength - Максимальная длина
 * @returns {string}
 */
export const truncateText = (text, maxLength = 100) => {
  if (!text) return '—';
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};

/**
 * Форматирует имя пользователя: "Имя Фамилия" или логин
 * @param {object} user - Пользователь с полями name, surname, username
 * @returns {string}
 */
export const formatUserName = (user) => {
  if (!user) return '—';
  const { name, surname, username } = user;
  const fullName = [name, surname].filter(Boolean).join(' ');
  return fullName || username || 'Пользователь';
};

/**
 * Форматирует статус (например, для будущих флагов)
 * @param {boolean} value
 * @param {string} trueLabel
 * @param {string} falseLabel
 * @returns {string}
 */
export const formatBoolean = (value, trueLabel = 'Да', falseLabel = 'Нет') => {
  return value ? trueLabel : falseLabel;
};

export default {
  formatDate,
  formatTime,
  formatDateTime,
  formatDuration,
  formatFileSize,
  truncateText,
  formatUserName,
  formatBoolean,
};
